/* eslint-disable no-console */
import { clearInputValues, removeAllErrors } from '../../utils/form-validation-utils';

let previousElementInFocus = null;

const getPreviousElementInFocus = () => (
  previousElementInFocus
);

const setPreviousElementInFocus = (element) => {
  previousElementInFocus = element;
};

const resetFocus = () => {
  if (getPreviousElementInFocus()) {
    getPreviousElementInFocus().focus();
  }
};

const onDocumentModalKeyUp = (event, modal) => {
  if (event.keyCode === 27) {
    closeAccountModal(modal); /* eslint-disable-line no-use-before-define */
  }
};

const closeAccountModal = (modal) => {
  // Clear any form values, input errors, error messages
  const form = modal.querySelector('.acct-login-modal-form');
  clearInputValues(form);
  removeAllErrors(form);
  form.querySelector('.form-error-message').classList.add('hide');
  // Remove active classes
  modal.classList.remove('modal-visible');
  modal.removeAttribute('style');
  const closeBtn = modal.querySelector('#close-btn');
  const overlay = document.querySelector('#modal-overlay');
  overlay.classList.remove('modal-visible');
  // Remove event listeners
  closeBtn.removeEventListener('click', closeAccountModal);
  overlay.removeEventListener('click', closeAccountModal);
  document.removeEventListener('keyup', onDocumentModalKeyUp);
  // Focus
  resetFocus();
};

const openAccountModal = (modal) => {
  if (!modal) {
    return;
  }
  // Check if overlay bg exists
  let overlay = document.querySelector('#modal-overlay');
  if (!overlay) {
    const body = document.getElementsByTagName('body')[0];
    overlay = document.createElement('div');
    body.appendChild(overlay);
    overlay.setAttribute('id', 'modal-overlay');
    overlay.classList.add('c-modalOverlay');
  }
  overlay.style.zIndex = '9998';
  // Add active classes
  modal.classList.add('modal-visible');
  overlay.classList.add('modal-visible');
  const closeBtn = modal.querySelector('#close-btn');
  // Focus
  setPreviousElementInFocus(document.activeElement);
  overlay.focus();
  console.log(document.activeElement);
  // Add events
  closeBtn.addEventListener('click', () => closeAccountModal(modal));
  overlay.addEventListener('click', () => closeAccountModal(modal));
  document.addEventListener('keyup', event => onDocumentModalKeyUp(event, modal));
};

export {
  openAccountModal,
  closeAccountModal,
};
/* eslint-enable no-console */
